import { Component, ChangeDetectionStrategy, ViewEncapsulation, input, computed, contentChildren, TemplateRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContentListItemComponent } from '../list.item';
import { Content, DynamicViewDirective } from '../../../overview';
import { BUTTON_COMPONENTS } from '../../../button';
import { Command } from '@workbuddy/ui/model';

export enum ContentListMode {
    Default = 'default',
    Borderless = 'borderless'
}

@Component({
    selector: 'w-content-list',
    templateUrl: 'content.list.component.html',
    styleUrls: ['content.list.component.less'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    host: {
        '[class]': '$mode()'
    },
    imports: [
        CommonModule,
        DynamicViewDirective,
        BUTTON_COMPONENTS
    ]
})
export class ContentListComponent {

    public $mode = input<ContentListMode>(ContentListMode.Default, { alias: 'mode' });

    public $headerTitle = input<Content>(null, { alias: 'headerTitle' });
    public $headerActions = input<Command[]>([], { alias: 'headerActions' });
    public $showHeader = input<boolean>(true, { alias: 'showHeader' });

    public $footerLeftCommands = input<Command[]>([], { alias: 'footerLeftActions' });
    public $footerRightCommands = input<Command[]>([], { alias: 'footerRightActions' });

    public $headerActionContent = input<Content>(null, { alias: 'headerActionContent' });
    public $footerRightContent = input<Content>(null, { alias: 'footerRightContent' });
    public $footerLeftContent = input<Content>(null, { alias: 'footerLeftContent' });

    protected $showHeaderAuto = computed(() => !!this.$showHeader() && (this.$headerTitle() || this.$headerActions()?.length > 0 || this.$headerActionContent()));
    protected $showFooter = computed(() => this.$footerLeftCommands()?.length > 0 || this.$footerRightCommands()?.length > 0 || this.$footerRightContent() || this.$footerLeftContent());

    protected $items = contentChildren(ContentListItemComponent, { read: TemplateRef });

    constructor() { }
}